import { db } from './firebase';
import { ref, query, orderByChild, limitToLast, get } from 'firebase/database';
import { UserProfile } from '../lib/progression';

/**
 * Fetches the top 50 users based on total XP from the Realtime Database.
 * Returns them sorted descending (highest XP first).
 */
export async function fetchLeaderboard(): Promise<UserProfile[]> {
  try {
    const usersRef = ref(db, 'users');
    const leaderboardQuery = query(usersRef, orderByChild('xp'), limitToLast(100));
    const snapshot = await get(leaderboardQuery);
    
    if (!snapshot.exists()) return [];
    
    const users: UserProfile[] = [];
    snapshot.forEach((childSnapshot) => {
      const val = childSnapshot.val();
      users.push({
        uid: childSnapshot.key || '',
        displayName: val.displayName || 'Giocatore',
        xp: val.xp ?? 0,
        level: val.level ?? 1,
        stats: val.stats || { played: 0, won: 0, lost: 0 },
        isPremium: val.isPremium ?? false
      });
    });
    
    // limitToLast queries return sorted ascending. We reverse to show highest XP first.
    return users.reverse();
  } catch (err) {
    console.error('[LeaderboardService] Error fetching leaderboard:', err);
    throw err;
  }
}
